export function randomNumberBetween(min: number, max: number): number {
    // We shift by min, ensure we stay in the correct range,
    // and use Math.floor for an integer.
    return Math.floor(Math.random() * (max - min + 1)) + min
}

export function formatAbbreviatedNumber(n: number): string {
    const abs = Math.abs(n)

    if (abs < 1_000) return `${n}`

    if (abs < 999_500) {
        const value = n / 1_000
        return `${stripTrailingZero(value.toFixed(1))}K`
    }

    if (abs < 999_500_000) {
        const value = n / 1_000_000
        return `${stripTrailingZero(value.toFixed(1))}M`
    }

    const value = n / 1_000_000_000
    return `${stripTrailingZero(value.toFixed(1))}B`
}

function stripTrailingZero(num: string): string {
    return num.replace(/\.0$/, '')
}
